import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const colorViewUiEvents = eventGroup({
  source: 'Modeler Color View UI',
  events: {
    highlightMenuClicked: type<void>(),
    highlightAttributeSelected: type<void>(),
    colorviewLegendColorChanged: type<void>(),
    colorviewTurnedOff: type<void>(),
    colorviewLegendExpanded: type<void>(),
    colorviewLegendCollapsed: type<void>(),
  },
});
